export const ORDER_MOCKS = {
  PENDING: {
    status: 'pending',
    amount: '1000.00',
    reference: null,
    confirmation_code: null,
  },
  PROCESSED: {
    status: 'processed',
    amount: '2100.00',
    reference: 'SOJMOCKZ8EQF',
    confirmation_code: '11UEKR',
  },
  CANCELED: {
    status: 'canceled',
    amount: '1000.00',
    reference: null,
    confirmation_code: null,
  },
  EXPIRED: {
    status: 'expired',
    amount: '1000.00',
    reference: null,
    confirmation_code: null,
  },
};
